import { jsx as o } from "react/jsx-runtime";
import { Grid as t } from "@chakra-ui/react";
function f({ children: r, ...i }) {
  return /* @__PURE__ */ o(t, { ...i, children: r });
}
export {
  f as Grid
};
